import { render, staticRenderFns } from "./SetPin.template.vue?vue&type=template&id=201baca9&scoped=true&"
var script = {}
import style0 from "./SetPin.template.vue?vue&type=style&index=0&id=201baca9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201baca9",
  null
  
)

export default component.exports